import styled from 'styled-components';

import { green } from 'utils/style/colors';

import Icon from 'components/Icon';
import { ChipProgress } from 'components/AssigneeChip/AssigneeChip';

type CellProps = {
  bgColor?: string;
};

export const Cell = styled('td')<CellProps>`
  background-color: ${(props) =>
    props.bgColor ? props.bgColor + ' !important' : 'white'};
`;
export const HeaderRow = styled('th')<CellProps>`
  border-radius: 10px;
  text-align: center !important;
  padding: 5px 10px;
  background-color: ${(props) => (props.bgColor ? props.bgColor : 'white')};
  // max-height: 3.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  position: sticky;
  top: 0;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 0em;
`;

export const HeaderColumnTitle = styled('div')<CellProps>`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
`;

export const HeaderColumn = styled(HeaderRow)<CellProps>`
  min-width: 150px;
  position: sticky;
  right: 0;
`;
export const HeaderColumnNoStick = styled(HeaderRow)<CellProps>`
  position: unset;
  ${(props) =>
    props.bgColor ? 'background-color: ' + props.bgColor + ' !important' : ''};
`;
export const HeaderColumnPrint = styled(HeaderRow)<CellProps>``;

export const Badge = styled('div')<CellProps>`
  background-color: ${(props) => (props.bgColor ? props.bgColor : 'white')};
  color: ${(props) => (props.bgColor === '#D74242' ? 'white' : 'black')};
`;

export const TargetRow = styled('div')`
  border-right: 2px solid ${green};
  padding-right: 0.8rem;
  margin: 0.5rem 0;
`;

export const TargetIcon = styled(Icon)`
  margin-left: 1rem;
`;

export const TargetValue = styled(ChipProgress)`
  min-width: 2rem;
  width: auto;
`;

export const TotalPercentageValue = styled(ChipProgress)<CellProps>`
  min-width: 2rem;
  width: auto;
  color: ${(props) => (props.bgColor === '#D74242' ? 'white' : 'black')}
  background-color: ${(props) => props.bgColor};
`;

export const BottomActions = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`;
